module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.ota) ? _c('div', [_c('div', {
    staticClass: "bg-blue-pale p-2 fs-small"
  }, [_vm._v("\n            Please note that you need to have active products on GYG in order to connect with Pluralo. "), _c('a', {
    staticClass: "darkest underlined",
    attrs: {
      "href": _vm.otaLink,
      "target": "_blank"
    }
  }, [_vm._v("Sign up with GetYourGuide")]), _vm._v(" if you haven't already.\n        ")]), _vm._v(" "), _c('list', {
    staticClass: "mt-4",
    attrs: {
      "header": _vm.productListHeader,
      "body": _vm.productListBody,
      "rows": _vm.products
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-e2a86066", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2a86066"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/otas/getYourGuide/integration/otaIntegration.vue
// module id = 3140
// module chunks = 0